export const ROUTES = {
  HOME: "/",
  CV_LIST: "/cvs",
  CV_EDITOR: "/cv-editor",
  CV_EDITOR_WITH_ID: (id: string | number) => `/cv-editor/${id}`,
  CV_EDITOR_PATTERN: "/cv-editor/:id",
  PROFILE: "/profile",
  ROLE_DEMO: "/role-demo",
  CV_DETAILS: (id: string | number) => `/person/${id}`,
  CV_DETAILS_PATTERN: "/person/:id",
  CV_NEW: "/cv-editor/new",

  // Operations Panel Routes (replacing admin routes gradually)
  OPERATIONS: "/operations",
  OPERATIONS_WITH_PATH: (path: string) => `/operations/${path}`,

  // Keep admin routes for backward compatibility during transition
  ADMIN: "/admin",
  ADMIN_WITH_PATH: (path: string) => `/admin/${path}`,

  CHAT: "/chat",
  MY_SKILLS: "/my-skills",
  PERSON_SKILLS: (id: string | number) => `/person/${id}/skills`,
  PERSON_SKILLS_PATTERN: "/person/:id/skills",
  CHAT_ABOUT_CANDIDATES: "/chat-about-candidates",
  CHANGELOG: "/changelog",

  // Employee Overview (main nav, not Operations — FS_04_EmployeeHub_06 Deviation 1)
  EMPLOYEES: "/employees",

  // Reports (main nav, not Operations — FS_05_Reporting_01, same precedent as Employee Overview)
  REPORTS: "/reports",
  REPORTS_WITH_PATH: (path: string) => `/reports/${path}`,

  // FAQ (main nav, all roles — FS_07_FAQSystem_01)
  FAQ: "/faq",
  FAQ_WITH_PATH: (path: string) => `/faq/${path}`,

  // Employee Hub
  EMPLOYEE_HUB: '/operations/employee-hub',

  // Talent Marketplace
  OPPORTUNITIES: '/opportunities',
  OPPORTUNITY_NEW: '/opportunities/new',
  OPPORTUNITY_DETAIL: (id: string | number) => `/opportunities/${id}`,
  OPPORTUNITY_DETAIL_PATTERN: '/opportunities/:id',
  OPPORTUNITY_EDIT: (id: string | number) => `/opportunities/${id}/edit`,
  OPPORTUNITY_EDIT_PATTERN: '/opportunities/:id/edit',
};
